import React, { useEffect, useState } from 'react';
import { applyUpdate, updateWaiting } from '../serviceWorkerRegistration';

// "A new version is ready" bar. The new version only takes over when the user
// taps Reload, so nobody is switched mid-sale. Shown signed in or not.
export default function UpdatePrompt() {
  const [ready, setReady] = useState(updateWaiting());

  useEffect(() => {
    const onReady = () => setReady(true);
    window.addEventListener('sb:update-available', onReady);
    return () => window.removeEventListener('sb:update-available', onReady);
  }, []);

  if (!ready) return null;

  return (
    <div role="status" style={{
      position: 'fixed', left: '50%', bottom: 'calc(var(--nav-h) + var(--safe-bottom) + 12px)', transform: 'translateX(-50%)',
      zIndex: 1000, display: 'flex', alignItems: 'center', gap: '0.75rem',
      background: '#172554', color: '#bfdbfe', border: '1px solid var(--color-accent)',
      borderRadius: '12px', padding: '0.6rem 0.75rem 0.6rem 1rem', fontSize: '0.85rem',
      boxShadow: '0 6px 20px rgba(0,0,0,0.35)', maxWidth: 'calc(100vw - 2rem)',
    }}>
      <span>A new version of ShopBook is ready.</span>
      <button type="button" onClick={applyUpdate} style={{
        flexShrink: 0, background: 'var(--color-accent)', color: '#fff', border: 'none',
        borderRadius: '8px', padding: '0.4rem 0.8rem', fontWeight: 700, fontSize: '0.8rem', cursor: 'pointer',
      }}>
        Reload
      </button>
    </div>
  );
}
